import styled from 'styled-components/macro';

const Paper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 1px 3px 0;
`;

export default Paper;
